/** Leading words that say "an allergy to", folded, longest first. */
const LEADING_PHRASES: readonly (readonly string[])[] = [
  ['حساسيه', 'من'], ['حساسيه', 'ضد'], ['حساسيه', 'تجاه'], ['حساسيه', 'على'], ['حساسيه', 'علي'],
  ['allergy', 'to'], ['allergic', 'to'], ['حساسيه'], ['allergy'],
];

const MARK = /\p{Mn}/u;
const LETTER_OR_DIGIT = /[\p{L}\p{Nd}]/u;

/**
 * Folds an allergen's name to the form it is matched by, exactly as the API's `AllergenNames.Normalize` does (Q75):
 * case, diacritics and tatweel, the hamza, ة/ه and ى/ي, punctuation and spacing, a leading "حساسية من", and "ال" at
 * the start of a word that keeps two letters without it. The picker uses it to find a catalogue entry by any of its
 * names; the API decides what an allergy matches. `normalize.cases.json` holds the two to each other.
 */
export function normalizeAllergenName(name: string | null | undefined): string {
  if (!name || !name.trim()) return '';

  let folded = '';
  for (const char of name.normalize('NFKD')) {
    if (MARK.test(char)) continue;
    switch (char.codePointAt(0)) {
      case 0x0640: // tatweel
      case 0x0621: // hamza on the line
        continue;
      case 0x0629: folded += 'ه'; continue;
      case 0x0649: folded += 'ي'; continue;
      case 0x0671: folded += 'ا'; continue;
    }
    folded += LETTER_OR_DIGIT.test(char) ? char.toLowerCase() : ' ';
  }

  const words = folded.split(' ').filter(Boolean);
  for (const phrase of LEADING_PHRASES) {
    if (words.length > phrase.length && phrase.every((word, i) => words[i] === word)) {
      words.splice(0, phrase.length);
      break;
    }
  }

  return words.map((word) => (word.length >= 4 && word.startsWith('ال') ? word.slice(2) : word)).join(' ');
}
